"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CardsavrSDKError_1 = __importDefault(require("./CardsavrSDKError"));
var CardsavrRestError = /** @class */ (function (_super) {
    __extends(CardsavrRestError, _super);
    function CardsavrRestError(response) {
        var _this = this;
        var _a, _b;
        var errors = Array.isArray(response.body) ?
            (_a = response.body) === null || _a === void 0 ? void 0 : _a.map(function (obj) { return obj._errors; }) :
            (_b = response.body) === null || _b === void 0 ? void 0 : _b._errors;
        _this = _super.call(this, errors, "CardsavrRestError ".concat(response.statusCode, ": ").concat(response.statusText)) || this;
        _this.response = response;
        _this.type = "CardsavrRestError";
        _this.statusCode = response.statusCode;
        _this.statusText = response.statusText;
        Object.setPrototypeOf(_this, CardsavrRestError.prototype);
        return _this;
    }
    return CardsavrRestError;
}(CardsavrSDKError_1.default));
exports.default = CardsavrRestError;
/*
message
stack
type (CardsavrRestError)
response.body._errors
response.body[0]._errors  (messages, jobs)

Request hydration:
    errors
        [
            "", ""
        ]
Plural post
    errors
        [
            {call, id?, index?, name, "message", entity_name, property_name}
        ]
    
    Response.body._errors
    Response.body[0]._errors
*/ 
//# sourceMappingURL=CardsavrRestError.js.map